





























import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class BibliographySearchConditionNavigation extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  mini!: boolean

  drawer: boolean = true

  @Emit('change')
  onChangeNavigation(): void {
    console.log('CollectionNavigation - change')
  }
}
